import {FC, useEffect, useState} from "react";
import {marked} from "marked";

interface IntelligenceMarkdownProps {
    text: string;
}

// Escapes raw HTML tags in the source text before Markdown parsing to prevent
// XSS from LLM-generated content while preserving standard Markdown syntax.
const escapeRawHtml = (text: string): string =>
    text.replace(/<[^>]*>/g, (match) =>
        match.replace(/</g, "&lt;").replace(/>/g, "&gt;")
    );

const removeAnchorLinks = (html: string): string => {
    const anchorLinksRegex =
        /<a\s+(?:[^>]*?\s+)?href=['"](#[^"']*?)['"][^>]*?>/g;
    return html.replace(anchorLinksRegex, "");
};

const IntelligenceMarkdown: FC<IntelligenceMarkdownProps> = ({text}) => {
    const [html, setHtml] = useState("");

    useEffect(() => {
        try {
            const safe = escapeRawHtml(text);
            const parsed = marked.parse(safe) as string;
            setHtml(removeAnchorLinks(parsed));
        } catch {
            setHtml(
                text
                    .replace(/&/g, "&amp;")
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;")
            );
        }
    }, [text]);

    return (
        <span
            className="pi-markdown"
            dangerouslySetInnerHTML={{__html: html}}
        />
    );
};

export default IntelligenceMarkdown;
